import { Container, Row, Col } from "react-bootstrap";
import styles from "./VirtualServersPage.module.css";
import { LowerMainBannerHeader, UpperMainBannerHeader } from "./DataCenterSvg";
import { useState, useEffect, useRef } from "react";
import { useLang } from "../LangContext";
import { useTheme } from "../ThemeContext";
import { motion } from "framer-motion";
import MinorHeader from "./MinorHeader";
import { s } from "framer-motion/client";
import { QuestionBlock, QuestionCard } from "./QuestionsModule";

function MainBanner({ isLg, isXl }) {
  const { s, toggleTheme } = useTheme();
  const { lang, changeLang, t } = useLang();

  return (
    <div className={styles.mainBannerContainer} style={s.VSMainBanner}>
      <Row>
        <Col xs={12} md={7}>
          <div className={`${styles.mainBannerTextBlock} h-100`}>
            <h4 style={{ color: s.DCProsHeader, letterSpacing: "1.5px" }}>
              {t("VHMainHeader")}
            </h4>
            <p style={{ color: s.DCProsText }}>
              {t("VHMainText1")}
              {(isLg || isXl) && <br />}
              {t("VHMainText2")}
              {(isLg || isXl) && <br />} {t("VHMainText3")}
            </p>
          </div>
        </Col>
        <Col xs={12} md={5}>
          <div className="d-flex h-100 justify-content-center align-items-center">
            <svg
              width="151"
              height="171"
              viewBox="0 0 151 171"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              style={{ overflow: "visible" }}
            >
              {/* Верхний кубик (справа) */}
              <motion.g
                initial={{ x: 0, y: 0 }}
                animate={{
                  x: [0, 0, 0, -75, -75, -75, -75, 0],
                  y: [0, 0, 0, 0, 0, 85, 85, 0],
                }}
                transition={{
                  duration: 4,
                  ease: "easeInOut",
                  repeat: Infinity,
                }}
              >
                <path
                  d="M80.6412 18.3771L105.927 3.46583C108.696 1.83268 110.081 1.0161 111.609 1.00023C113.138 0.98437 114.539 1.77208 117.341 3.34731L144.153 18.4173C147.005 20.0202 148.431 20.8217 149.215 22.1637C150 23.506 150 25.1435 150 28.4186V58.1558C150 61.4301 150 63.0682 149.215 64.4101C148.431 65.7519 147.005 66.5547 144.153 68.1565L117.341 83.2265C114.539 84.8015 113.138 85.589 111.609 85.5737C110.081 85.5585 108.696 84.7423 105.927 83.108L80.6412 68.1967C77.8871 66.5738 76.5099 65.7615 75.755 64.4387C75 63.116 75 61.5161 75 58.3144V28.2598C75 25.0588 75 23.4584 75.755 22.1358C76.5099 20.8133 77.8869 20.0013 80.6412 18.3771Z"
                  fill={s.SquareIcon2Fill}
                  stroke={s.SquareIcon2Stroke}
                  strokeWidth="2"
                />
                <path
                  d="M101.734 5.66135C106.351 2.91668 108.658 1.54425 111.569 1.52094C114.48 1.49742 116.853 2.83202 121.601 5.50118L139.475 15.5512C144.135 18.1717 146.466 19.4818 146.528 21.1369C146.591 22.792 144.362 24.1597 139.904 26.8948L122.641 37.487C117.844 40.4302 115.446 41.9019 112.41 41.9011C109.375 41.9004 106.978 40.4276 102.186 37.4822L84.8137 26.8057C80.4759 24.1398 78.307 22.8068 78.3303 21.1853C78.3534 19.5638 80.5602 18.2516 84.9736 15.6273L101.734 5.66135Z"
                  fill={s.SquareIcon2Fill}
                  stroke={s.SquareIcon2Stroke}
                  strokeWidth="2"
                />
                <path
                  d="M111.46 41.4386L111.46 85.9997"
                  stroke={s.SquareIcon2Stroke}
                  strokeWidth="2"
                />
              </motion.g>

              {/* Нижний кубик (слева) */}
              <motion.g
                initial={{ x: 0, y: 0 }}
                animate={{
                  x: [0, 0, 0, 75, 75, 75, 75, 0],
                  y: [0, 0, 0, 0, 0, -85, -85, 0],
                }}
                transition={{
                  duration: 4,
                  ease: "easeInOut",
                  repeat: Infinity,
                }}
              >
                <path
                  d="M7.04155 102.454L20.813 94.1367C28.5269 89.4776 32.3837 87.1481 36.6415 87.1028C40.8992 87.0574 44.8026 89.3045 52.6089 93.7984L67.7247 102.5C70.9023 104.329 72.491 105.244 73.3652 106.776C74.2395 108.307 74.2395 110.176 74.2395 113.913V141.905C74.2395 145.642 74.2395 147.511 73.3652 149.043C72.491 150.574 70.9023 151.489 67.7247 153.318L43.0132 167.544C39.8907 169.341 38.3293 170.24 36.6263 170.222C34.9232 170.204 33.3804 169.272 30.295 167.409L7.04155 153.364C3.97296 151.511 2.43867 150.584 1.5976 149.075C0.756351 147.565 0.756348 145.739 0.756348 142.086V113.732C0.756348 110.079 0.756351 108.253 1.5976 106.744C2.43867 105.234 3.97296 104.308 7.04155 102.454Z"
                  fill="#E5EEF7"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M52.9459 93.0988L68.1337 101.842C69.6924 102.739 70.9112 103.441 71.8458 104.112C72.8012 104.798 73.5104 105.486 74.0219 106.382C74.5335 107.278 74.7714 108.249 74.887 109.44C75 110.604 75 112.038 75 113.872V141.946C75 143.78 75 145.213 74.887 146.378C74.7714 147.568 74.5335 148.539 74.0219 149.436C73.5104 150.332 72.8012 151.02 71.8458 151.706C70.911 152.377 69.692 153.079 68.1331 153.976L43.4119 168.207L43.3865 168.222L43.3515 168.242C41.8198 169.124 40.6219 169.814 39.5943 170.276C38.5435 170.749 37.6171 171.01 36.6206 171C35.6239 170.989 34.703 170.708 33.662 170.213C32.6439 169.729 31.4603 169.014 29.9467 168.099L6.62459 154.013C5.1192 153.104 3.94189 152.393 3.03969 151.719C2.11711 151.029 1.43333 150.344 0.941102 149.461C0.449061 148.577 0.220086 147.625 0.108747 146.46C1.0421e-06 145.32 0 143.919 0 142.127V113.691C0 111.899 1.0421e-06 110.498 0.108747 109.358C0.220086 108.193 0.449061 107.24 0.941102 106.357C1.43333 105.474 2.11711 104.789 3.03969 104.099C3.94189 103.425 5.1192 102.714 6.62459 101.804L20.466 93.4443C24.2927 91.1332 27.2118 89.3701 29.7063 88.1836C32.2237 86.9862 34.3619 86.3489 36.6358 86.3245C38.9096 86.3004 41.0603 86.8921 43.6014 88.0357C46.1192 89.1689 49.0733 90.8696 52.9459 93.0988ZM42.9919 89.4605C40.5653 88.3685 38.6354 87.8594 36.6515 87.8805C34.6676 87.9016 32.7485 88.4517 30.3445 89.5951C27.9254 90.7459 25.0695 92.4696 21.2 94.8068L7.4286 103.124C5.88152 104.059 4.76851 104.732 3.933 105.357C3.11102 105.971 2.60711 106.503 2.25809 107.13C1.90907 107.756 1.7177 108.471 1.61858 109.51C1.51781 110.565 1.51707 111.89 1.51707 113.732V142.086C1.51707 143.927 1.51781 145.253 1.61858 146.308C1.7177 147.347 1.90907 148.062 2.25809 148.688C2.60711 149.314 3.11102 149.847 3.933 150.461C4.76851 151.086 5.88152 151.759 7.4286 152.693L30.6818 166.738C32.2372 167.677 33.3575 168.353 34.3003 168.801C35.2278 169.243 35.9298 169.436 36.6363 169.444C37.3429 169.451 38.0485 169.273 38.9848 168.851C39.9313 168.425 41.0578 167.778 42.6186 166.88L42.644 166.865L67.3558 152.639C68.9575 151.717 70.1103 151.053 70.9759 150.431C71.8277 149.82 72.3501 149.285 72.7128 148.649C73.0754 148.014 73.2745 147.285 73.3775 146.224C73.4822 145.145 73.4831 143.789 73.4831 141.905V113.913C73.4831 112.029 73.4822 110.672 73.3775 109.594C73.2745 108.533 73.0754 107.804 72.7128 107.168C72.3501 106.533 71.8277 105.998 70.9759 105.387C70.1103 104.765 68.9575 104.1 67.3558 103.178L52.2397 94.4767C48.3238 92.2222 45.4338 90.5595 42.9919 89.4605Z"
                  fill={s.SquareIcon1Stroke}
                />
                <path
                  d="M23.8153 92.0619C29.8155 88.4079 32.8156 86.5808 36.5991 86.5496C40.3828 86.5183 43.468 88.295 49.6389 91.8487L60.7678 98.2574C66.8257 101.746 69.8547 103.49 69.9362 105.694C70.0175 107.897 67.1201 109.718 61.3257 113.359L50.7093 120.031C44.474 123.949 41.3563 125.909 37.4105 125.908C33.4649 125.906 30.35 123.946 24.12 120.024L13.306 113.218C7.66739 109.668 4.84797 107.894 4.87817 105.735C4.90837 103.576 7.77688 101.829 13.5139 98.3353L23.8153 92.0619Z"
                  fill="#E5EEF7"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M66.8613 102.797C65.3839 101.685 63.166 100.406 60.1184 98.6507L48.9895 92.2419C45.8853 90.4543 43.6227 89.153 41.6688 88.2958C39.7368 87.4479 38.2177 87.0855 36.6113 87.0988C35.005 87.1119 33.5039 87.4994 31.6126 88.3788C29.7002 89.268 27.5001 90.6061 24.4817 92.4445L14.1803 98.7178C11.2938 100.476 9.19412 101.756 7.80118 102.863C6.42435 103.958 5.81967 104.822 5.80689 105.739C5.79411 106.657 6.37452 107.527 7.72059 108.635C9.08241 109.756 11.1462 111.056 13.983 112.842L24.797 119.648C27.9304 121.621 30.2165 123.058 32.2058 124.009C34.1743 124.95 35.7369 125.358 37.4102 125.358C39.0836 125.359 40.6468 124.952 42.6164 124.012C44.6072 123.062 46.8951 121.626 50.0315 119.655L60.6476 112.983C63.5628 111.151 65.6842 109.817 67.0783 108.667C68.4564 107.531 69.0407 106.642 69.0062 105.706C68.9716 104.77 68.3221 103.896 66.8613 102.797ZM68.3236 102.119C69.9121 103.314 70.8179 104.414 70.8645 105.682C70.9114 106.95 70.0878 108.072 68.589 109.307C67.1146 110.523 64.9069 111.91 62.0513 113.705L51.3342 120.439C48.2601 122.371 45.8864 123.863 43.7847 124.866C41.6503 125.885 39.6818 126.457 37.4094 126.457C35.1373 126.456 33.1695 125.883 31.0364 124.863C28.9362 123.859 26.5645 122.366 23.4931 120.433L12.5791 113.563C9.80084 111.814 7.65205 110.462 6.21057 109.275C4.745 108.069 3.93061 106.972 3.94803 105.73C3.96544 104.489 4.81021 103.4 6.30931 102.208C7.78377 101.036 9.96998 99.7044 12.7968 97.983L23.198 91.6486C26.1553 89.8477 28.441 88.4558 30.4629 87.5157C32.5177 86.5603 34.4083 86.0185 36.5854 86.0005C38.7627 85.9824 40.6781 86.4928 42.7772 87.4139C44.843 88.3203 47.1936 89.6741 50.2347 91.4253L61.4674 97.8939C64.4526 99.613 66.7607 100.942 68.3236 102.119Z"
                  fill={s.SquareIcon1Stroke}
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M35.7236 170.77V126.054H37.2407V170.77H35.7236Z"
                  fill={s.SquareIcon1Stroke}
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M50.302 106.345L50.8726 105.75C53.072 103.455 52.5142 100.489 49.2077 98.5355C45.2325 96.1866 38.787 96.1866 34.8118 98.5355C34.55 98.6902 34.3057 98.8513 34.0789 99.0176L33.0458 99.7762L31.6474 99.261C28.4601 98.0866 24.2116 98.319 21.4431 99.955C18.3175 101.802 18.2213 104.761 21.1541 106.676L21.164 106.682L21.1934 106.701C21.2755 106.755 21.3587 106.806 21.4431 106.856C21.5259 106.905 21.621 106.958 21.721 107.013L21.7495 107.028L34.4116 114.502L34.4465 114.525C34.583 114.615 34.7205 114.701 34.86 114.784C38.9579 117.205 45.6019 117.205 49.6998 114.784C53.3232 112.643 53.743 109.323 50.9549 106.91L50.302 106.345ZM19.8086 107.435C16.1811 105.089 16.2873 101.448 20.1287 99.1781C23.5223 97.173 28.7263 96.8902 32.631 98.3289C32.8992 98.1321 33.188 97.9416 33.4974 97.7588C38.1987 94.981 45.8209 94.981 50.5221 97.7588C54.4349 100.071 55.0904 103.578 52.4901 106.291C55.7727 109.132 55.2814 113.039 51.0142 115.561C46.1903 118.411 38.3693 118.411 33.5456 115.56C33.3781 115.462 33.2169 115.36 33.0611 115.257L20.4633 107.822C20.3503 107.76 20.2353 107.696 20.1287 107.633C20.022 107.57 19.919 107.506 19.8184 107.441L19.8086 107.435Z"
                  fill="#23C1FF"
                />
              </motion.g>
            </svg>
          </div>
        </Col>
      </Row>
    </div>
  );
}

function QuestionsModule() {
  const [openedCard, setOpenedCard] = useState(null);
  const { lang, changeLang, t } = useLang();

  const cards = [
    {
      header: t("qHeader1"),
      isOpened: true,
      description: t("qDescr1"),
      key: 0,
    },
    {
      header: t("qHeader2"),
      isOpened: true,
      description: t("qDescr2"),
      key: 1,
    },
    {
      header: t("qHeader3"),
      isOpened: true,
      description: t("qDescr3"),
      key: 2,
    },
    {
      header: t("qHeader4"),
      isOpened: true,
      description: t("qDescr4"),
      key: 3,
    },
  ];
  return (
    <Row className="mt-2  gx-3 gy-3">
      <Col xs={12} md={12} lg={6}>
        <Row xs={1} className="gy-2">
          {cards.map((el) => (
            <Col>
              <QuestionCard
                {...el}
                isOpened={el.key === openedCard}
                setOpened={setOpenedCard}
                index={el.key}
                key={el.key}
              />
            </Col>
          ))}
        </Row>
      </Col>
      <Col xs={12} md={6} lg={3}>
        <QuestionBlock
          header={t("qCardHeader1")}
          description={t("qCardDescr1")}
          linkText={t("qCardLink1")}
          link={"https://wiki.qwins.co/"}
        />
      </Col>
      <Col xs={12} md={6} lg={3}>
        <QuestionBlock
          header={t("qCardHeader2")}
          description={t("qCardDescr2")}
          linkText={t("qCardLink2")}
          link={"https://t.me/qwinshelp"}
        />
      </Col>
    </Row>
  );
}

function CountryCard({ text, price, header, tariff, displayParams }) {
  const { s } = useTheme();
  const { t } = useLang();

  return (
    <div
      className={styles.countryCard}
      style={{ ...s.DCProsCard, height: "auto" }}
    >
      <div
        className={styles.countryHeaderContainer}
        style={s.VSCountryCardHeaderContainer}
      >
        <div
          className={styles.countryBlackEl}
          style={{ backgroundColor: s.DCProsHeader }}
        >
          <h4 style={{ fontSize: "17px", margin: "0", color: s.guideCard2Bg }}>
            {header}
          </h4>
        </div>
        <p style={{ color: s.DCProsHeader }}>{price}</p>
      </div>

      <div className="mt-3" style={{ width: "100%" }}>
        {text.map((el, index) => (
          <div
            key={index}
            className={styles.countryParamsRow}
            style={{
              display: "flex",
              width: "100%",
              overflow: "hidden",
              textAlign: "left",
            }}
          >
            <p
              className={styles.countryParamsHeader}
              style={{
                color: s.VSCountryCardVal,
                marginLeft: "15px",
                whiteSpace: "normal",
                wordBreak: "break-word",
                overflowWrap: "break-word",
                color: s.DCProsText,
              }}
            >
              • {el}
            </p>
          </div>
        ))}
        <h6
          style={{
            textAlign: "left",
            marginTop: "10px",
            fontSize: "18px",
            color: s.cardBlinkColor,
          }}
        >
          {t("VHTariffHeader")}
        </h6>
        {tariff.map((el, index) => (
          <div
            key={index}
            className={styles.countryParamsRow}
            style={{
              display: "flex",
              width: "100%",
              overflow: "hidden",

              textAlign: "left",
            }}
          >
            <p
              className={styles.countryParamsHeader}
              style={{
                color: s.VSCountryCardVal,
                marginLeft: "15px",
                whiteSpace: "normal",
                wordBreak: "break-word",
                overflowWrap: "break-word",
                color: s.DCProsText,
              }}
            >
              • {el}
            </p>
          </div>
        ))}
      </div>

      <a href="https://my.qwins.co" style={{ textDecoration: "none" }}>
        <button
          className={`${styles.countryBuyBtn} mt-3`}
          style={{
            color: s.guideCard2Bg,
            ...s.VSMainBannerBtnHover,
          }}
        >
          {t("VSBuyBtnText")}
        </button>
      </a>
    </div>
  );
}
function CountryCards() {
  const { lang, changeLang, t } = useLang();
  const cards = t("VHTariffs");
  return (
    <div className="mt-5">
      <Row
        xs={1}
        md={2}
        xxl={4}
        className={`gy-4 ${cards.length === 1 ? "justify-content-center" : ""}`}
      >
        {cards.map((el, index) => {
          return (
            <Col>
              <CountryCard {...el} key={index} />
            </Col>
          );
        })}
      </Row>
    </div>
  );
}

function Pros2Card({ header, description, picSrc, children }) {
  const { s, toggleTheme } = useTheme();

  const descriptionClass = `${styles.cardDescr}`;
  const headerClass = `${styles.cardHeader} m-0`;
  const divClass = `${styles.card} h-100 ${styles.pros2CardStructure}`;
  return (
    <Col>
      <div
        className={divClass}
        style={s.cardBg}
        //   style={{ paddingBottom: "7px" }}
      >
        <Row>
          <Col xs={12}>
            <div className="d-flex align-items-center gap-3">
              <div>
                <div className="panel-container" style={s.card2IconBG}>
                  {children}
                </div>
              </div>
              {/* <img src={picSrc} alt="IMG" className={styles.prosSmallGif} /> */}
              <h4
                className={headerClass}
                style={{ fontSize: "22px", ...s.cardHeader }}
              >
                {header}
              </h4>
            </div>
          </Col>
          <Col xs={12}>
            <p
              className={descriptionClass}
              style={{ marginTop: "28px", ...s.card2Descr }}
              // style={{ maxWidth: "82%" }}
            >
              {description}
            </p>
          </Col>
        </Row>
      </div>
    </Col>
  );
}

function ProsModule2({ isXl }) {
  const { s, toggleTheme } = useTheme();
  const { lang, changeLang, t } = useLang();
  const prosCards = [
    {
      header: t("VHProsHeader1"),
      text: t("VHProsText1"),
      pic: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
        >
          <path
            d="M2.22222 8.9381C6.24302 8.4869 9.42989 5.61872 9.93122 2H2.22222V8.9381ZM2.22222 10.9506V18H17.7778V2H12.1673C11.6462 6.72442 7.47158 10.4816 2.22222 10.9506ZM1.11111 0H18.8889C19.5026 0 20 0.44772 20 1V19C20 19.5523 19.5026 20 18.8889 20H1.11111C0.497467 20 0 19.5523 0 19V1C0 0.44772 0.497467 0 1.11111 0ZM13.3333 14H15.5556V16H13.3333V14Z"
            fill={s.cardBlinkColor}
          />
        </svg>
      ),
    },
    {
      header: t("VHProsHeader2"),
      text: t("VHProsText2"),
      pic: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          // className="panel-icon"
        >
          <path
            d="M2.22222 8.88889H17.7778V2.22222H2.22222V8.88889ZM20 1.11111V18.8889C20 19.5026 19.5026 20 18.8889 20H1.11111C0.497467 20 0 19.5026 0 18.8889V1.11111C0 0.497467 0.497467 0 1.11111 0H18.8889C19.5026 0 20 0.497467 20 1.11111ZM17.7778 11.1111H2.22222V17.7778H17.7778V11.1111ZM4.44444 13.3333H7.77778V15.5556H4.44444V13.3333ZM4.44444 4.44444H7.77778V6.66667H4.44444V4.44444Z"
            fill={s.cardBlinkColor}
          />
        </svg>
      ),
    },
    {
      header: t("VHProsHeader3"),
      text: t("VHProsText3"),
      pic: (
        <svg
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3.41421 2H7V0H0V7H2V3.41421L6.29289 7.7071L7.7071 6.29289L3.41421 2ZM18 11H16V14.5858L11.7071 10.2929L10.2929 11.7071L14.5858 16H11V18H18V11Z"
            fill={s.cardBlinkColor}
          />
        </svg>
      ),
    },
  ];
  return (
    <Row xs={1} lg={3} className="g-4 mt-2 mt-lg-3 align-items-stretch">
      {prosCards.map((el) => (
        <Pros2Card header={el.header} description={el.text}>
          {el.pic}
        </Pros2Card>
      ))}
    </Row>
  );
}

export default function VirtualHostingPage({ windowSize }) {
  const { lang, changeLang, t } = useLang();
  const { s, toggleTheme } = useTheme();

  return (
    <>
      <MainBanner isLg={windowSize.isLg} isXl={windowSize.isXl} />
      <ProsModule2 isXl={windowSize.isXl} />
      <MinorHeader
        header={t("VHMinorHeader")}
        isXs={windowSize.isXs}
        isSm={windowSize.isSm}
      />
      <CountryCards />
      <div style={{ textAlign: "left" }}>
        <h4
          className={`${styles.minorHeader} mt-5 mb-0`}
          style={{
            ...s.minorHeader,
            fontFamily: "Gilroy-semibold",
            fontSize: "clamp(25px, 5vw, 28px)",
          }}
        >
          {t("qMinorHeader")}
        </h4>
      </div>

      <QuestionsModule />
    </>
  );
}
